export const WalletStyles = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    padding: '20px 10px',
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
  },
  tabsContainer: {
    width: '100%',
    borderBottom: '1px solid rgba(123, 162, 56, 0.3)',
    marginBottom: '10px',
  },
  card: {
    backgroundColor: 'rgba(123, 162, 56, 0.08)',
    borderRadius: '12px',
    border: '1px solid rgba(123, 162, 56, 0.2)',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box' as const,
  },
  balanceCard: {
    backgroundColor: 'rgba(123, 162, 56, 0.12)',
    borderRadius: '16px',
    border: '1px solid rgba(123, 162, 56, 0.3)',
    padding: '30px 20px',
    width: '100%',
    boxSizing: 'border-box' as const,
    textAlign: 'center' as const,
  },
  balanceAmount: {
    fontSize: 'clamp(1.5rem, 2vw + 1rem, 2.5rem)',
    fontWeight: 700,
    color: '#7BA238',
  },
  balanceLabel: {
    fontSize: '0.85rem',
    color: 'rgba(123, 162, 56, 0.7)',
    textTransform: 'uppercase' as const,
    letterSpacing: '1px',
  },
  actionButton: {
    backgroundColor: '#7BA238',
    color: 'white',
    fontWeight: 'bold',
    '&:hover': { backgroundColor: '#6a912f' },
    borderRadius: '8px',
    padding: '10px 24px',
    textTransform: 'none' as const,
  },
  outlinedButton: {
    color: '#7BA238',
    borderColor: '#7BA238',
    '&:hover': {
      backgroundColor: 'rgba(123, 162, 56, 0.1)',
      borderColor: '#7BA238',
    },
    borderRadius: '8px',
    textTransform: 'none' as const,
  },
  sectionTitle: {
    color: '#7BA238',
    fontWeight: 600,
    fontSize: '1.1rem',
    marginBottom: '12px',
  },
  listItem: {
    borderBottom: '1px solid rgba(123, 162, 56, 0.1)',
    padding: '12px 0',
  },
  qrContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
    padding: '20px',
  },
  inputField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': { borderColor: 'rgba(123, 162, 56, 0.3)' },
      '&:hover fieldset': { borderColor: '#7BA238' },
      '&.Mui-focused fieldset': { borderColor: '#7BA238' },
    },
    '& .MuiInputLabel-root.Mui-focused': { color: '#7BA238' },
  },
  noDataText: {
    color: 'rgba(123, 162, 56, 0.5)',
    textAlign: 'center' as const,
    padding: '40px 0',
  },
};
